import React from 'react'
import AgentRecruitmentForm from '@components/AgentRecruitmentForm'

const AgentRecruitment = ({ title, content1, content2, dictionary, lang }) => {
    return (
        <div className='w-full bg-maincolor'>
            <section className='px-3 mt-5 container-wide mx-auto'>
                <AgentRecruitmentForm title={title} content1={content1} content2={content2} dictionary={dictionary.recruitmentForm} lang={lang} />
            </section>
        </div>
    )
}

export default AgentRecruitment